const RERENDER_CERTONA = 'RERENDER_CERTONA';
export default RERENDER_CERTONA;
